import { ErrorMsg } from '../error-msg/error-msg';
import { useTranslations } from 'next-intl';

interface OtherRecommendCommentProps {
	register: any;
	error: any;
    no: number;
	inputChange: (value: string) => void;
}

export const OtherRecommendComment = ({ 
	register, 
	error, 
	no,
	inputChange,
}:OtherRecommendCommentProps) => {
	
	const t = useTranslations('General');

	return (
		<div key={`textarea_${no}`} className="survey-form__textfield" data-error={!!error.otherRecommendComment}>
			<textarea 
				name="otherRecommendComment"
				{...register('otherRecommendComment', {
					onChange: (e: any) => {
						inputChange(e.target.value)
					},
				})}
				className="survey-form__textarea" 
				placeholder={t('lbl_GSabaSurveyAnswer')}
			>
			</textarea>
			{error.otherRecommendComment?.message && <ErrorMsg msg={error.otherRecommendComment.message} />}
			<div className="survey-form__textarea-text">
				{t('lbl_GSabaSurveyCharactersBetween01')}
			</div> 
		</div>
	)
}